export const subregions_hi = {
    "उत्तरी अफ्रीका": [
        "DZA",
        "EGY",
        "LBY",
        "MAR",
        "SDN",
        "TUN",
        "ESH"
    ],
    "उप-सहारा अफ्रीका": [
        "IOT",
        "BDI",
        "COM",
        "DJI",
        "ERI",
        "ETH",
        "ATF",
        "KEN",
        "MDG",
        "MWI",
        "MUS",
        "MYT",
        "MOZ",
        "REU",
        "RWA",
        "SYC",
        "SOM",
        "SSD",
        "UGA",
        "TZA",
        "ZMB",
        "ZWE",
        "AGO",
        "CMR",
        "CAF",
        "TCD",
        "COG",
        "COD",
        "GNQ",
        "GAB",
        "STP",
        "BWA",
        "SWZ",
        "LSO",
        "NAM",
        "ZAF",
        "BEN",
        "BFA",
        "CPV",
        "CIV",
        "GMB",
        "GHA",
        "GIN",
        "GNB",
        "LBR",
        "MLI",
        "MRT",
        "NER",
        "NGA",
        "SHN",
        "SEN",
        "SLE",
        "TGO"
    ],
    "लैटिन अमेरिका और कैरेबियन": [
        "AIA",
        "ATG",
        "ABW",
        "BHS",
        "BRB",
        "BES",
        "VGB",
        "CYM",
        "CUB",
        "CUW",
        "DMA",
        "DOM",
        "GRD",
        "GLP",
        "HTI",
        "JAM",
        "MTQ",
        "MSR",
        "PRI",
        "BLM",
        "KNA",
        "LCA",
        "MAF",
        "VCT",
        "SXM",
        "TTO",
        "TCA",
        "VIR",
        "BLZ",
        "CRI",
        "SLV",
        "GTM",
        "HND",
        "MEX",
        "NIC",
        "PAN",
        "ARG",
        "BOL",
        "BVT",
        "BRA",
        "CHL",
        "COL",
        "ECU",
        "FLK",
        "GUF",
        "GUY",
        "PRY",
        "PER",
        "SGS",
        "SUR",
        "URY",
        "VEN"
    ],
    "उत्तरी अमेरिका": [
        "BMU",
        "CAN",
        "GRL",
        "SPM",
        "USA"
    ],
    "मध्य एशिया": [
        "KAZ",
        "KGZ",
        "TJK",
        "TKM",
        "UZB"
    ],
    "पूर्वी एशिया": [
        "CHN",
        "HKG",
        "MAC",
        "PRK",
        "JPN",
        "MNG",
        "KOR"
    ],
    "दक्षिण-पूर्वी एशिया": [
        "BRN",
        "KHM",
        "IDN",
        "LAO",
        "MYS",
        "MMR",
        "PHL",
        "SGP",
        "THA",
        "TLS",
        "VNM"
    ],
    "दक्षिणी एशिया": [
        "AFG",
        "BGD",
        "BTN",
        "IND",
        "IRN",
        "MDV",
        "NPL",
        "PAK",
        "LKA"
    ],
    "पश्चिमी एशिया": [
        "ARM",
        "AZE",
        "BHR",
        "CYP",
        "GEO",
        "IRQ",
        "ISR",
        "JOR",
        "KWT",
        "LBN",
        "OMN",
        "QAT",
        "SAU",
        "PSE",
        "SYR",
        "TUR",
        "ARE",
        "YEM"
    ],
    "पूर्वी यूरोप": [
        "BLR",
        "BGR",
        "CZE",
        "HUN",
        "POL",
        "MDA",
        "ROU",
        "RUS",
        "SVK",
        "UKR"
    ],
    "उत्तरी यूरोप": [
        "ALA",
        "GGY",
        "JEY",
        "DNK",
        "EST",
        "FRO",
        "FIN",
        "ISL",
        "IRL",
        "IMN",
        "LVA",
        "LTU",
        "NOR",
        "SJM",
        "SWE",
        "GBR"
    ],
    "दक्षिणी यूरोप": [
        "ALB",
        "AND",
        "BIH",
        "HRV",
        "GIB",
        "GRC",
        "VAT",
        "ITA",
        "MLT",
        "MNE",
        "MKD",
        "PRT",
        "SMR",
        "SRB",
        "SVN",
        "ESP"
    ],
    "पश्चिमी यूरोप": [
        "AUT",
        "BEL",
        "FRA",
        "DEU",
        "LIE",
        "LUX",
        "MCO",
        "NLD",
        "CHE"
    ],
    "ऑस्ट्रेलिया और न्यूजीलैंड": [
        "AUS",
        "CXR",
        "CCK",
        "HMD",
        "NZL",
        "NFK"
    ],
    "मेलानेशिया": [
        "FJI",
        "NCL",
        "PNG",
        "SLB",
        "VUT"
    ],
    "माइक्रोनेशिया": [
        "GUM",
        "KIR",
        "MHL",
        "FSM",
        "NRU",
        "MNP",
        "PLW",
        "UMI"
    ],
    "पोलीनेशिया": [
        "ASM",
        "COK",
        "PYF",
        "NIU",
        "PCN",
        "WSM",
        "TKL",
        "TON",
        "TUV",
        "WLF"
    ]
}